<div class="pmd-sidebar-scrollbar">
	<!--Sidebar-->
	<div class="d-flex justify-content-between align-items-center p-3">
		<div class="pmd-sidebar-brand">
			<a [routerLink]="authService.user?.isAdmin ? '/invoice' : appGlobals.homePath"
				class="navbar-brand d-flex justify-content-between align-items-center">
				<img src="assets/images/PurchaseSingleLogo.svg"
					class="fils-logo-icon" />
				<img src="assets/images/PurchaseLogo.svg"
					class="fils-logo" />
			</a>
		</div>
	</div>
	<ul class="nav flex-column pmd-sidebar-nav pmd-sidebar-nav_list">
		<ng-container *ngFor="let section of topSections; index as i">
			<h6 class="text-d600 fw-semibold fs-14 title-header px-3"
				*ngIf="section.name">
				{{ section.name }}
			</h6>
			<ng-container *ngFor="let menu of section.menus">
				<li class="nav-item"
					routerLinkActive='active'>
					<a class="nav-link"
						[routerLink]="menu.path || (menu.subMenus?.length ? menu.subMenus[0].path : null)"
						quicklink
						class="nav-link"
						[ngClass]="{'active': menu.name === activeMenu?.name}"
						[routerLinkActive]="menu.path ? 'active' : ''"
						(click)="openInnerSidebar(menu)">
						<i class="pmd-nav-item-icon"
							*ngIf="menu.svg"
							[innerHTML]="menu.svg | safeHtml">
						</i>
						<span class="flex-grow-1"
							*ngIf="menu.name"> {{ menu.name }}</span>
						<span *ngIf="menu.subMenus?.length"
							class="hide-on-brand">
							<svg width="6"
								height="11"
								viewBox="0 0 7 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_4453_14990)">
									<path
										d="M0.721623 0.262639C1.01452 -0.0302546 1.48928 -0.0302545 1.78217 0.262639L6.78217 5.26264C6.92282 5.40329 7.0019 5.594 7.0019 5.79291C7.0019 5.99182 6.92282 6.18253 6.78217 6.32319L1.78217 11.3232C1.48928 11.6161 1.01451 11.6161 0.721623 11.3232C0.428737 11.0303 0.428747 10.5555 0.721623 10.2626L5.19135 5.79291L0.721623 1.32319C0.42873 1.03029 0.42873 0.555532 0.721623 0.262639Z"
										fill="#373737" />
								</g>
								<defs>
									<clipPath id="clip0_4453_14990">
										<rect width="7"
											height="12"
											fill="white" />
									</clipPath>
								</defs>
							</svg>
						</span>
					</a>
				</li>
			</ng-container>
			<hr *ngIf="topSections?.length !== i + 1">
		</ng-container>
		<!-- <ng-container>
			<li class="nav-item"
				*ngIf="authService.user?.isOwner || authService.user?.isOutlet || authService.user?.isLeadAdmin"
				routerLinkActive='active'
				role="none"
				pmdBoundary="viewport"
				containerClass="pf-menu-tooltip"
				container="body">
				<a class="nav-link"
					role="menuitem"
					[ngClass]="{'aTagDisabled':!authService.secondaryOwnerCanAccess('/dashboard')}"
					[routerLink]="['/dashboard']"
					id="dashboardLink">
					<i class="pmd-nav-item-icon">
						<svg width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M11.75 11.3351C11.75 11.0894 11.7495 10.9501 11.7412 10.8488C11.7386 10.8164 11.7344 10.7964 11.7324 10.7853C11.7272 10.7784 11.721 10.7727 11.7139 10.7677C11.7023 10.7658 11.6829 10.7633 11.6533 10.7609C11.552 10.7526 11.4125 10.7521 11.167 10.7521H8.83301C8.58748 10.7521 8.44797 10.7526 8.34668 10.7609C8.31626 10.7634 8.29658 10.7657 8.28516 10.7677C8.27816 10.7727 8.27174 10.7784 8.2666 10.7853C8.26462 10.7965 8.26142 10.8166 8.25879 10.8488C8.25051 10.9501 8.25 11.0894 8.25 11.3351V16.7521H11.75V11.3351ZM13.25 16.7521H14.833C15.3121 16.7521 15.6269 16.7512 15.8672 16.7316C16.0982 16.7127 16.1941 16.6794 16.249 16.6515L16.3721 16.5763C16.4885 16.4917 16.5844 16.3806 16.6504 16.2511L16.6719 16.2013C16.6938 16.1403 16.7153 16.0423 16.7295 15.8683C16.7491 15.628 16.75 15.3139 16.75 14.8351V8.80579C16.75 8.41469 16.7468 8.25112 16.7334 8.15247L16.7158 8.06946C16.6933 7.98909 16.6604 7.91208 16.6172 7.84095L16.5703 7.77161C16.5401 7.73073 16.503 7.69073 16.4219 7.62122L16.0098 7.29309L10.3584 2.89661C10.2038 2.7764 10.1184 2.71101 10.0527 2.66712C10.0352 2.65543 10.0225 2.64817 10.0146 2.64368C10.0048 2.64188 9.99523 2.64188 9.98535 2.64368C9.97754 2.64817 9.96476 2.65543 9.94727 2.66712L9.6416 2.89661L3.99023 7.29309C3.68227 7.53262 3.5551 7.636 3.48535 7.70716L3.42969 7.77161C3.37995 7.83886 3.33925 7.91244 3.30957 7.99036L3.28418 8.06946C3.25677 8.16739 3.25 8.2848 3.25 8.80579V14.8351C3.25 15.3139 3.2509 15.628 3.27051 15.8683C3.2894 16.0996 3.32165 16.1962 3.34961 16.2511L3.42578 16.3741C3.51037 16.4904 3.62169 16.5856 3.75098 16.6515L3.80078 16.673C3.86179 16.6949 3.9591 16.7174 4.13281 16.7316C4.37311 16.7512 4.68791 16.7521 5.16699 16.7521H6.75V11.3351C6.75 11.1141 6.74925 10.9033 6.76367 10.7267C6.77882 10.5413 6.81459 10.3288 6.92285 10.1163L6.9834 10.007C7.13551 9.75898 7.35362 9.55677 7.61426 9.42395L7.77344 9.35559C7.9314 9.29934 8.08571 9.27711 8.22461 9.26575C8.40111 9.25133 8.61215 9.25208 8.83301 9.25208H11.167C11.3879 9.25208 11.5989 9.25133 11.7754 9.26575C11.9143 9.27711 12.0686 9.29934 12.2266 9.35559L12.3857 9.42395L12.4941 9.48548C12.7423 9.63761 12.9443 9.85558 13.0771 10.1163L13.1455 10.2755C13.2018 10.4336 13.225 10.5877 13.2363 10.7267C13.2507 10.9033 13.25 11.1141 13.25 11.3351V16.7521ZM18.25 14.8351C18.25 15.2892 18.2504 15.6749 18.2246 15.9904C18.2014 16.2741 18.1545 16.5516 18.04 16.8185L17.9863 16.9318C17.7836 17.3296 17.4752 17.6625 17.0967 17.8947L16.9307 17.9884C16.6291 18.1421 16.3135 18.2002 15.9893 18.2267C15.6737 18.2525 15.2873 18.2521 14.833 18.2521H5.16699C4.71266 18.2521 4.32629 18.2525 4.01074 18.2267C3.72708 18.2035 3.45038 18.1555 3.18359 18.0411L3.06934 17.9884C2.6715 17.7857 2.33862 17.4773 2.10645 17.0988L2.01367 16.9318C1.86008 16.6302 1.80188 16.3146 1.77539 15.9904C1.74964 15.6749 1.75 15.2892 1.75 14.8351V8.49231C1.75266 8.19041 1.76784 7.92241 1.83984 7.66516L1.9082 7.45618C1.98641 7.25095 2.09264 7.05715 2.22363 6.88001L2.30664 6.77552C2.50856 6.53858 2.76807 6.34284 3.06934 6.10852L8.7207 1.71302L8.9082 1.56751C9.10474 1.4177 9.3289 1.26507 9.58594 1.19544L9.79199 1.15442C9.99926 1.12696 10.2109 1.14043 10.4141 1.19544L10.54 1.23743C10.8271 1.34797 11.0712 1.55113 11.2793 1.71302L16.9307 6.10852L17.1787 6.30188C17.4153 6.48924 17.6176 6.66533 17.7764 6.88001L17.8994 7.06263C18.0133 7.25028 18.1008 7.45312 18.1602 7.66516L18.1924 7.79505C18.2374 8.01285 18.2478 8.24076 18.25 8.49231V14.8351Z"
								fill="#646464" />
						</svg>
					</i>
					<span class="flex-grow-1">Dashboard</span>
				</a>
			</li>
			<li class="nav-item"
				*ngIf="!authService.user?.isLeadAdmin"
				routerLinkActive="active"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<a class="nav-link"
					[ngClass]="{'aTagDisabled':!authService.secondaryOwnerCanAccess('/invoice')}"
					role="menuitem"
					[routerLink]="['/invoice']">
					<i class="pmd-nav-item-icon">
						<svg width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.917 6.5C15.917 5.78756 15.9167 5.2982 15.8857 4.91895C15.863 4.64089 15.8264 4.45932 15.7783 4.3252L15.7266 4.20508C15.5797 3.91697 15.3562 3.6759 15.082 3.50782L14.9619 3.44043C14.8179 3.36705 14.6185 3.31152 14.248 3.28125C13.8688 3.25028 13.3793 3.25 12.667 3.25H7.33399C6.62155 3.25 6.13219 3.25027 5.75293 3.28125C5.47472 3.30399 5.29333 3.34156 5.15918 3.38965L5.03907 3.44043C4.75098 3.58727 4.5099 3.81082 4.3418 4.08496L4.27442 4.20508C4.20103 4.34911 4.14551 4.54852 4.11524 4.91895C4.08425 5.2982 4.08399 5.78756 4.08399 6.5V16.0264L5.18457 15.2266L5.29102 15.1621C5.54903 15.0334 5.86279 15.0633 6.09375 15.248L7.73047 16.5566L9.55957 15.2266L9.66211 15.1641C9.90997 15.0386 10.2113 15.0594 10.4414 15.2266L12.2705 16.5566L13.9072 15.248L14.0107 15.1777C14.2624 15.0375 14.5773 15.0529 14.8164 15.2266L15.917 16.0264V6.5ZM17.417 17.5C17.417 17.782 17.259 18.0399 17.0078 18.168C16.7565 18.2959 16.4547 18.2722 16.2266 18.1064L14.3965 16.7754L12.7607 18.0859C12.4969 18.2968 12.1248 18.305 11.8516 18.1064L10 16.7598L8.15039 18.1064C7.91117 18.2804 7.59561 18.2958 7.34375 18.1553L7.24024 18.0859L5.60352 16.7754L3.77539 18.1064C3.54725 18.2724 3.24454 18.296 2.99317 18.168C2.7421 18.0399 2.58399 17.7819 2.58399 17.5V6.5C2.58399 5.81231 2.58299 5.25138 2.62012 4.79688C2.65797 4.33363 2.73939 3.91515 2.93848 3.52442L3.06348 3.30078C3.37571 2.79169 3.82336 2.37716 4.3584 2.10449L4.50684 2.03516C4.85492 1.88591 5.22564 1.81924 5.63086 1.78614C6.08537 1.749 6.6463 1.75 7.33399 1.75H12.667C13.3545 1.75 13.9157 1.74903 14.3701 1.78614C14.8334 1.82398 15.2519 1.90542 15.6426 2.10449L15.8662 2.22949C16.3755 2.54177 16.7908 2.98921 17.0635 3.52442L17.1328 3.67285C17.282 4.02086 17.3478 4.39176 17.3809 4.79688C17.418 5.25138 17.417 5.81231 17.417 6.5V17.5Z"
								fill="#646464" />
						</svg>

					</i>
					<span class="flex-grow-1"
						aria-hidden="true">Invoice</span>
				</a>
			</li>
			<li *ngIf="(authService.user?.isOwner && authService.user?.isPaidUser === false)"
				class="nav-item position-relative cursor-pointer"
				routerLinkActive="active"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<div class="cursor-pointer">
					<a class="nav-link"
						role="menuitem"
						[routerLink]="['/banking/account-details']">
						<i class="pmd-nav-item-icon">
							<svg width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M16.75 15.499C16.75 15.2534 16.7495 15.114 16.7412 15.0127C16.7386 14.9803 16.7344 14.9603 16.7324 14.9492C16.7275 14.9427 16.7215 14.9374 16.7149 14.9326C16.7034 14.9307 16.6839 14.9273 16.6533 14.9248C16.6026 14.9207 16.5421 14.9182 16.4639 14.917L16.167 14.916H3.83301C3.58749 14.916 3.44798 14.9165 3.34669 14.9248C3.31528 14.9274 3.29544 14.9306 3.28419 14.9326C3.27765 14.9374 3.27148 14.9427 3.26661 14.9492C3.26464 14.9603 3.26144 14.9805 3.2588 15.0127C3.25052 15.114 3.25001 15.2534 3.25001 15.499V16.166L3.25098 16.4629C3.25216 16.5412 3.25465 16.6016 3.2588 16.6523C3.26136 16.6837 3.26464 16.7035 3.26661 16.7148C3.27146 16.7215 3.27763 16.7265 3.28419 16.7314C3.29541 16.7334 3.31512 16.7376 3.34669 16.7402C3.44798 16.7485 3.58749 16.749 3.83301 16.749H16.167L16.4639 16.748C16.5421 16.7469 16.6026 16.7444 16.6533 16.7402C16.684 16.7377 16.7035 16.7334 16.7149 16.7314C16.7215 16.7266 16.7275 16.7215 16.7324 16.7148C16.7344 16.7036 16.7386 16.6838 16.7412 16.6523C16.7495 16.551 16.75 16.4117 16.75 16.166V15.499ZM12.833 13.416H15.083V8.24902H12.833V13.416ZM8.667 13.416H11.333V8.24902H8.667V13.416ZM4.917 13.416H7.167V8.24902H4.917V13.416ZM16.7432 4.8418C16.7415 4.81944 16.7396 4.8041 16.7383 4.79492C16.7336 4.78639 16.728 4.77887 16.7207 4.77246C16.7121 4.76918 16.698 4.76419 16.6768 4.75781L16.293 4.66602L10.127 3.2959C10.0697 3.28316 10.0396 3.27676 10.0176 3.27246L10.0068 3.26953H9.99317C10.0002 3.26889 10.0002 3.269 9.98243 3.27246L9.87305 3.2959L3.70704 4.66602C3.51012 4.70977 3.40131 4.73435 3.32325 4.75781C3.30133 4.76441 3.28689 4.76918 3.27833 4.77246C3.27112 4.77887 3.26536 4.78644 3.26075 4.79492C3.25942 4.80411 3.25848 4.81955 3.25684 4.8418C3.2509 4.92304 3.25001 5.03403 3.25001 5.23535V6.16602L3.25098 6.46289C3.25216 6.5412 3.25465 6.60162 3.2588 6.65234C3.26136 6.68368 3.26464 6.70353 3.26661 6.71484C3.27146 6.72145 3.27763 6.72653 3.28419 6.73145C3.29541 6.73341 3.31512 6.73764 3.34669 6.74023C3.44798 6.74851 3.58749 6.74902 3.83301 6.74902H16.167L16.4639 6.74805C16.5421 6.74687 16.6026 6.74438 16.6533 6.74023C16.684 6.73772 16.7035 6.73341 16.7149 6.73145C16.7215 6.72655 16.7275 6.72147 16.7324 6.71484C16.7344 6.70356 16.7386 6.68383 16.7412 6.65234C16.7495 6.55103 16.75 6.41166 16.75 6.16602V5.23535C16.75 5.03403 16.7491 4.92304 16.7432 4.8418ZM18.25 6.16602C18.25 6.38694 18.2508 6.59787 18.2363 6.77441C18.225 6.91337 18.2018 7.06753 18.1455 7.22559L18.0772 7.38477C17.9443 7.64548 17.7423 7.86352 17.4941 8.01562L17.3857 8.07617C17.1734 8.18437 16.9607 8.22019 16.7754 8.23535C16.7151 8.24028 16.6504 8.24112 16.583 8.24316V13.4209C16.6504 13.4229 16.7151 13.4248 16.7754 13.4297C16.9144 13.4411 17.0685 13.4642 17.2266 13.5205L17.3857 13.5889L17.4941 13.6494C17.7423 13.8015 17.9443 14.0196 18.0772 14.2803L18.1455 14.4395C18.2018 14.5975 18.225 14.7517 18.2363 14.8906C18.2508 15.0672 18.25 15.2781 18.25 15.499V16.166C18.25 16.3869 18.2508 16.5979 18.2363 16.7744C18.225 16.9134 18.2018 17.0675 18.1455 17.2256L18.0772 17.3848C17.9443 17.6455 17.7423 17.8635 17.4941 18.0156L17.3857 18.0762C17.1734 18.1844 16.9607 18.2202 16.7754 18.2354C16.687 18.2426 16.5898 18.2464 16.4873 18.248L16.167 18.249H3.83301C3.61215 18.249 3.40111 18.2498 3.22462 18.2354C3.08564 18.224 2.9315 18.2009 2.77344 18.1445L2.61426 18.0762C2.35382 17.9434 2.13545 17.742 1.98341 17.4941L1.92286 17.3848C1.81462 17.1723 1.77883 16.9597 1.76368 16.7744C1.75646 16.686 1.75362 16.5889 1.75196 16.4863L1.75001 16.166V15.499C1.75001 15.2781 1.74925 15.0672 1.76368 14.8906C1.77883 14.7053 1.81462 14.4927 1.92286 14.2803L1.98341 14.1709C2.13546 13.9231 2.35382 13.7217 2.61426 13.5889L2.77344 13.5205C2.9315 13.4642 3.08565 13.4411 3.22462 13.4297C3.28495 13.4248 3.34963 13.4229 3.417 13.4209V8.24316C3.34964 8.24112 3.28494 8.24028 3.22462 8.23535C3.08564 8.22398 2.9315 8.20085 2.77344 8.14453L2.61426 8.07617C2.35382 7.94338 2.13545 7.74196 1.98341 7.49414L1.92286 7.38477C1.81462 7.17233 1.77883 6.95973 1.76368 6.77441C1.75646 6.68601 1.75362 6.58888 1.75196 6.48633L1.75001 6.16602V5.23535C1.75001 5.05546 1.74982 4.88032 1.76075 4.73145C1.77238 4.57318 1.79958 4.39476 1.87891 4.20996L1.97657 4.01855C2.08675 3.83531 2.23353 3.67565 2.40821 3.5498L2.53126 3.4707C2.65454 3.40074 2.7777 3.35553 2.89161 3.32129C3.03458 3.27831 3.20621 3.24118 3.38184 3.20215L9.54786 1.83105L9.69532 1.7998C9.7481 1.78963 9.804 1.78043 9.86133 1.77539L10 1.76953C10.0462 1.76953 10.0927 1.77136 10.1387 1.77539L10.3047 1.7998C10.3575 1.80999 10.4074 1.82111 10.4522 1.83105L16.6182 3.20215L16.876 3.25977C16.9585 3.27939 17.037 3.29982 17.1084 3.32129C17.2223 3.35553 17.3455 3.40074 17.4688 3.4707L17.5918 3.5498L17.7568 3.68652C17.912 3.83391 18.0361 4.01195 18.1211 4.20996L18.1719 4.34668C18.2135 4.48239 18.2305 4.61267 18.2393 4.73145C18.2502 4.88032 18.25 5.05546 18.25 5.23535V6.16602Z"
									fill="#646464" />
							</svg>
						</i>
						<span class="flex-grow-1">Banking</span>
					</a>
				</div>
			</li>

			<li class="nav-item position-relative cursor-pointer"
				[ngClass]="{'aTagDisabled':!authService.secondaryOwnerCanAccess('/banking/account-details')}"
				*ngIf="(authService.user?.isOwner && authService.user?.isPaidUser)"
				routerLinkActive="active"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<div (click)="toggleSubmenu('banking')"
					class="cursor-pointer">
					<a class="nav-link"
						role="menuitem">
						<i class="pmd-nav-item-icon">
							<svg width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M16.75 15.499C16.75 15.2534 16.7495 15.114 16.7412 15.0127C16.7386 14.9803 16.7344 14.9603 16.7324 14.9492C16.7275 14.9427 16.7215 14.9374 16.7149 14.9326C16.7034 14.9307 16.6839 14.9273 16.6533 14.9248C16.6026 14.9207 16.5421 14.9182 16.4639 14.917L16.167 14.916H3.83301C3.58749 14.916 3.44798 14.9165 3.34669 14.9248C3.31528 14.9274 3.29544 14.9306 3.28419 14.9326C3.27765 14.9374 3.27148 14.9427 3.26661 14.9492C3.26464 14.9603 3.26144 14.9805 3.2588 15.0127C3.25052 15.114 3.25001 15.2534 3.25001 15.499V16.166L3.25098 16.4629C3.25216 16.5412 3.25465 16.6016 3.2588 16.6523C3.26136 16.6837 3.26464 16.7035 3.26661 16.7148C3.27146 16.7215 3.27763 16.7265 3.28419 16.7314C3.29541 16.7334 3.31512 16.7376 3.34669 16.7402C3.44798 16.7485 3.58749 16.749 3.83301 16.749H16.167L16.4639 16.748C16.5421 16.7469 16.6026 16.7444 16.6533 16.7402C16.684 16.7377 16.7035 16.7334 16.7149 16.7314C16.7215 16.7266 16.7275 16.7215 16.7324 16.7148C16.7344 16.7036 16.7386 16.6838 16.7412 16.6523C16.7495 16.551 16.75 16.4117 16.75 16.166V15.499ZM12.833 13.416H15.083V8.24902H12.833V13.416ZM8.667 13.416H11.333V8.24902H8.667V13.416ZM4.917 13.416H7.167V8.24902H4.917V13.416ZM16.7432 4.8418C16.7415 4.81944 16.7396 4.8041 16.7383 4.79492C16.7336 4.78639 16.728 4.77887 16.7207 4.77246C16.7121 4.76918 16.698 4.76419 16.6768 4.75781L16.293 4.66602L10.127 3.2959C10.0697 3.28316 10.0396 3.27676 10.0176 3.27246L10.0068 3.26953H9.99317C10.0002 3.26889 10.0002 3.269 9.98243 3.27246L9.87305 3.2959L3.70704 4.66602C3.51012 4.70977 3.40131 4.73435 3.32325 4.75781C3.30133 4.76441 3.28689 4.76918 3.27833 4.77246C3.27112 4.77887 3.26536 4.78644 3.26075 4.79492C3.25942 4.80411 3.25848 4.81955 3.25684 4.8418C3.2509 4.92304 3.25001 5.03403 3.25001 5.23535V6.16602L3.25098 6.46289C3.25216 6.5412 3.25465 6.60162 3.2588 6.65234C3.26136 6.68368 3.26464 6.70353 3.26661 6.71484C3.27146 6.72145 3.27763 6.72653 3.28419 6.73145C3.29541 6.73341 3.31512 6.73764 3.34669 6.74023C3.44798 6.74851 3.58749 6.74902 3.83301 6.74902H16.167L16.4639 6.74805C16.5421 6.74687 16.6026 6.74438 16.6533 6.74023C16.684 6.73772 16.7035 6.73341 16.7149 6.73145C16.7215 6.72655 16.7275 6.72147 16.7324 6.71484C16.7344 6.70356 16.7386 6.68383 16.7412 6.65234C16.7495 6.55103 16.75 6.41166 16.75 6.16602V5.23535C16.75 5.03403 16.7491 4.92304 16.7432 4.8418ZM18.25 6.16602C18.25 6.38694 18.2508 6.59787 18.2363 6.77441C18.225 6.91337 18.2018 7.06753 18.1455 7.22559L18.0772 7.38477C17.9443 7.64548 17.7423 7.86352 17.4941 8.01562L17.3857 8.07617C17.1734 8.18437 16.9607 8.22019 16.7754 8.23535C16.7151 8.24028 16.6504 8.24112 16.583 8.24316V13.4209C16.6504 13.4229 16.7151 13.4248 16.7754 13.4297C16.9144 13.4411 17.0685 13.4642 17.2266 13.5205L17.3857 13.5889L17.4941 13.6494C17.7423 13.8015 17.9443 14.0196 18.0772 14.2803L18.1455 14.4395C18.2018 14.5975 18.225 14.7517 18.2363 14.8906C18.2508 15.0672 18.25 15.2781 18.25 15.499V16.166C18.25 16.3869 18.2508 16.5979 18.2363 16.7744C18.225 16.9134 18.2018 17.0675 18.1455 17.2256L18.0772 17.3848C17.9443 17.6455 17.7423 17.8635 17.4941 18.0156L17.3857 18.0762C17.1734 18.1844 16.9607 18.2202 16.7754 18.2354C16.687 18.2426 16.5898 18.2464 16.4873 18.248L16.167 18.249H3.83301C3.61215 18.249 3.40111 18.2498 3.22462 18.2354C3.08564 18.224 2.9315 18.2009 2.77344 18.1445L2.61426 18.0762C2.35382 17.9434 2.13545 17.742 1.98341 17.4941L1.92286 17.3848C1.81462 17.1723 1.77883 16.9597 1.76368 16.7744C1.75646 16.686 1.75362 16.5889 1.75196 16.4863L1.75001 16.166V15.499C1.75001 15.2781 1.74925 15.0672 1.76368 14.8906C1.77883 14.7053 1.81462 14.4927 1.92286 14.2803L1.98341 14.1709C2.13546 13.9231 2.35382 13.7217 2.61426 13.5889L2.77344 13.5205C2.9315 13.4642 3.08565 13.4411 3.22462 13.4297C3.28495 13.4248 3.34963 13.4229 3.417 13.4209V8.24316C3.34964 8.24112 3.28494 8.24028 3.22462 8.23535C3.08564 8.22398 2.9315 8.20085 2.77344 8.14453L2.61426 8.07617C2.35382 7.94338 2.13545 7.74196 1.98341 7.49414L1.92286 7.38477C1.81462 7.17233 1.77883 6.95973 1.76368 6.77441C1.75646 6.68601 1.75362 6.58888 1.75196 6.48633L1.75001 6.16602V5.23535C1.75001 5.05546 1.74982 4.88032 1.76075 4.73145C1.77238 4.57318 1.79958 4.39476 1.87891 4.20996L1.97657 4.01855C2.08675 3.83531 2.23353 3.67565 2.40821 3.5498L2.53126 3.4707C2.65454 3.40074 2.7777 3.35553 2.89161 3.32129C3.03458 3.27831 3.20621 3.24118 3.38184 3.20215L9.54786 1.83105L9.69532 1.7998C9.7481 1.78963 9.804 1.78043 9.86133 1.77539L10 1.76953C10.0462 1.76953 10.0927 1.77136 10.1387 1.77539L10.3047 1.7998C10.3575 1.80999 10.4074 1.82111 10.4522 1.83105L16.6182 3.20215L16.876 3.25977C16.9585 3.27939 17.037 3.29982 17.1084 3.32129C17.2223 3.35553 17.3455 3.40074 17.4688 3.4707L17.5918 3.5498L17.7568 3.68652C17.912 3.83391 18.0361 4.01195 18.1211 4.20996L18.1719 4.34668C18.2135 4.48239 18.2305 4.61267 18.2393 4.73145C18.2502 4.88032 18.25 5.05546 18.25 5.23535V6.16602Z"
									fill="#646464" />
							</svg>
						</i>
						<span class="flex-grow-1">Banking</span>
					</a>
					<span class="material-symbols-outlined submenu-toggle-icon"
						[ngClass]="{'open': isSubmenuOpen.banking, 'arrow-show':isOpen}">
						keyboard_arrow_down
					</span>
				</div>
				<ul class="submenu"
					[ngClass]="{'open': isSubmenuOpen.banking}"
					*ngIf="isOpen">
					<li class="submenu-item"
						routerLinkActive="active"> 
						<a class="submenu-link"
							[ngClass]="{'aTagDisabled':!authService.secondaryOwnerCanAccess('/banking/account-details')}"
							[routerLink]="['/banking/account-details']">Account</a>
					</li>
					<li class="submenu-item"
						routerLinkActive="active">
						<a class="submenu-link"
							[ngClass]="{'aTagDisabled':!authService.secondaryOwnerCanAccess('/payments')}"
							[routerLink]="['/payments']">Payment</a>
					</li>
					<li class="submenu-item"
						routerLinkActive="active"
						*ngIf="canShowBeneficiary">
						<a class="submenu-link"
							[routerLink]="['/banking/beneficiary-list']">
							Beneficiary</a>
					</li>
				</ul>
			</li>

			<li class="nav-item"
				*ngIf="!authService.user?.isLeadAdmin && (authService.user.isPaidUser || authService.user.isAdmin)"
				routerLinkActive="active"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<a class="nav-link"
					role="menuitem"
					[ngClass]="{'aTagDisabled':!authService.secondaryOwnerCanAccess('/tag')}"
					[routerLink]="['/tag']">
					<i class="pmd-nav-item-icon position-relative"
						aria-hidden="true">
							<svg width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M7.64551 3.83496L8.16211 3.84082C8.323 3.84856 8.47487 3.86556 8.62402 3.90137L8.80664 3.95312C8.98699 4.01175 9.16019 4.09113 9.32227 4.19043L9.51074 4.32227C9.69375 4.46444 9.86426 4.63769 10.0615 4.83496L16.1445 10.9189L16.5879 11.3662C16.722 11.5047 16.8419 11.6332 16.9443 11.7539C17.1548 12.0019 17.3368 12.266 17.4414 12.5879L17.4932 12.7715C17.5818 13.1415 17.5818 13.5274 17.4932 13.8975L17.4414 14.0811C17.3368 14.403 17.1549 14.668 16.9443 14.916C16.7395 15.1573 16.4657 15.4298 16.1445 15.751L14.083 17.8125C13.7618 18.1337 13.4894 18.4074 13.248 18.6123C13.0309 18.7966 12.801 18.9586 12.5312 19.0664L12.4131 19.1094C11.9885 19.2473 11.5353 19.2646 11.1035 19.1611L10.9199 19.1094C10.5981 19.0048 10.3339 18.8228 10.0859 18.6123C9.96524 18.5098 9.8367 18.39 9.69824 18.2559L9.25098 17.8125L2.75098 11.3125C2.55375 11.1153 2.37948 10.9456 2.23731 10.7627L2.10645 10.5732C2.00706 10.411 1.9268 10.2381 1.86816 10.0576L1.81641 9.875C1.78061 9.72581 1.76457 9.57402 1.75684 9.41309L1.75 8.89648V7.25098C1.75 6.79684 1.74963 6.41115 1.77539 6.0957C1.80189 5.7714 1.85999 5.45591 2.01367 5.1543L2.10645 4.9873C2.33864 4.60884 2.67153 4.30035 3.06934 4.09766L3.18359 4.04492C3.45036 3.93059 3.72711 3.88256 4.01074 3.85938C4.32629 3.83359 4.71266 3.83496 5.16699 3.83496H7.64551ZM8.34277 0.917969L8.74609 0.918945C9.1229 0.922022 9.42801 0.936839 9.72363 1.00781L9.96875 1.07715C10.2113 1.15596 10.4441 1.26296 10.6621 1.39648L10.79 1.48047C11.0819 1.68404 11.346 1.95345 11.7021 2.30957L18.0303 8.6377L18.082 8.69434C18.3223 8.98892 18.3049 9.42364 18.0303 9.69824C17.7557 9.97285 17.3209 9.99031 17.0264 9.75L16.9697 9.69824L10.6416 3.37012C10.2984 3.02693 10.1305 2.86238 10.001 2.76074L9.87891 2.67578C9.76137 2.60376 9.63569 2.54639 9.50488 2.50391L9.37305 2.4668C9.28247 2.44505 9.18685 2.43243 9.0332 2.42578L8.34277 2.41797H5C4.58579 2.41797 4.25 2.08218 4.25 1.66797C4.25 1.25376 4.58579 0.917969 5 0.917969H8.34277ZM3.25 8.89648L3.25488 9.34473C3.25865 9.4359 3.26512 9.48263 3.27539 9.52539L3.31934 9.66211C3.33767 9.70634 3.35968 9.74909 3.38477 9.79004L3.42676 9.84961C3.47962 9.91664 3.57627 10.0167 3.81152 10.252L10.3115 16.752L10.7422 17.1787C10.8632 17.296 10.9647 17.3907 11.0566 17.4688C11.2336 17.619 11.3252 17.6636 11.3838 17.6826L11.5234 17.7168C11.6656 17.7393 11.8121 17.7275 11.9502 17.6826L12.001 17.6621C12.0596 17.6344 12.1439 17.5812 12.2764 17.4688C12.4601 17.3127 12.6828 17.0906 13.0215 16.752L15.084 14.6895C15.4226 14.3508 15.6448 14.1281 15.8008 13.9443C15.9507 13.7677 15.9956 13.6767 16.0146 13.6182L16.0488 13.4775C16.0638 13.3828 16.0638 13.2861 16.0488 13.1914L16.0146 13.0518C15.9956 12.9932 15.951 12.9016 15.8008 12.7246C15.7228 12.6327 15.628 12.5311 15.5107 12.4102L15.084 11.9795L9.00098 5.89648C8.76615 5.66165 8.66566 5.56464 8.59863 5.51172L8.53906 5.46973C8.49797 5.44454 8.45455 5.42267 8.41016 5.4043L8.27344 5.36035C8.23076 5.35011 8.18463 5.34361 8.09375 5.33984L7.64551 5.33496H5.16699C4.68791 5.33496 4.37311 5.33486 4.13281 5.35449C3.95917 5.36869 3.8618 5.39116 3.80078 5.41309L3.75098 5.43457C3.62175 5.50041 3.51035 5.59575 3.42578 5.71191L3.34961 5.83496C3.32163 5.88987 3.28943 5.98623 3.27051 6.21777C3.25088 6.45801 3.25 6.7721 3.25 7.25098V8.89648Z"
									fill="#646464" />
							</svg>

					</i>
					<span class="flex-grow-1"
						aria-hidden="true"> Dashboard Tags </span>
				</a>
			</li>
			
			<li class="nav-item"
				*ngIf="authService.user?.role == 'Admin'"
				routerLinkActive="active"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<a class="nav-link"
					role="menuitem"
					[ngClass]="{'aTagDisabled':!authService.secondaryOwnerCanAccess('/payments')}"
					[routerLink]="['/payments']">
					<i class="pmd-nav-item-icon">
						<svg width="26"
							height="27"
							viewBox="0 0 26 27"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd"
								clip-rule="evenodd"
								d="M17 1.65799C14.0492 1.65799 11.6575 4.04997 11.6575 7C11.6575 9.95003 14.0492 12.342 17 12.342C19.9508 12.342 22.3425 9.95003 22.3425 7C22.3425 4.04997 19.9508 1.65799 17 1.65799ZM10 7C10 3.13379 13.1342 0 17 0C20.8657 0 24 3.13379 24 7C24 10.8662 20.8657 14 17 14C13.1342 14 10 10.8662 10 7Z"
								fill="#646464" />
							<path fill-rule="evenodd"
								clip-rule="evenodd"
								d="M11.1519 15.5484C9.52154 15.5484 8.11005 16.5068 7.43617 17.9028C7.37248 18.0347 7.27316 18.1455 7.14981 18.2222L6.29074 18.7563L7.70406 22.9578L14.853 22.7329C14.8608 22.7327 14.8687 22.7325 14.8765 22.7325C16.3698 22.7325 17.8261 22.2598 19.0427 21.3797L24.0717 17.7442C24.5182 17.4212 24.6099 16.7858 24.2742 16.3468C24.0853 16.0997 23.802 15.9683 23.5122 15.9683C23.3211 15.9683 23.1293 16.0255 22.9609 16.1451L22.9482 16.1539L19.4124 18.558C19.3073 18.9978 19.0843 19.3909 18.7803 19.6997C18.3495 20.1379 17.7518 20.4101 17.093 20.4101H12.7953C12.3746 20.4101 12.0336 20.0635 12.0336 19.6359C12.0336 19.2083 12.3746 18.8617 12.7953 18.8617H17.093C17.332 18.8617 17.5465 18.7643 17.7028 18.6052C17.86 18.4454 17.9561 18.2268 17.9561 17.985C17.9561 17.501 17.57 17.1083 17.093 17.1083H14.7121C14.5026 17.1083 14.3022 17.0205 14.1583 16.8656C13.4038 16.0536 12.3369 15.5484 11.1519 15.5484ZM19.1979 16.841L22.0953 14.8709C22.5257 14.5675 23.0211 14.4199 23.5122 14.4199C24.2534 14.4199 24.9882 14.7571 25.477 15.3966M19.1979 16.841C18.7957 16.0784 18.0039 15.5599 17.093 15.5599H15.0267C14.015 14.5933 12.6514 14 11.1519 14C9.00026 14 7.13011 15.2203 6.17338 17.0142L5.78578 17.2551L5.68529 16.9564C5.54922 16.5519 5.11629 16.336 4.71825 16.4742L0.515439 17.9337C0.324244 18.0001 0.166837 18.141 0.0778525 18.3254C-0.0111318 18.5097 -0.0244019 18.7225 0.0409621 18.9168L2.58383 26.4761C2.71991 26.8806 3.15283 27.0964 3.55087 26.9582L7.75363 25.4988C7.94482 25.4324 8.10223 25.2915 8.19122 25.1071C8.2802 24.9228 8.29347 24.71 8.22811 24.5157L8.21969 24.4907L14.8886 24.2809C16.6941 24.2783 18.4547 23.7056 19.9261 22.6412L24.9549 19.0058C26.1064 18.1728 26.3451 16.5319 25.477 15.3966M6.44169 23.9913C6.44358 23.9972 6.44555 24.003 6.44758 24.0088L6.54013 24.2839L3.77898 25.2428L1.72895 19.1486L4.49014 18.1897L4.64301 18.6442C4.64808 18.6612 4.65376 18.678 4.66005 18.6948L6.44169 23.9913Z"
								fill="#646464" />
							<path
								d="M16.3615 3.57159V4.24119C15.5937 4.47697 15.0422 5.1122 15.0422 5.85727C15.0422 6.8024 15.9298 7.57159 17.0211 7.57159C17.3848 7.57159 17.6806 7.82791 17.6806 8.14295C17.6806 8.458 17.3848 8.71432 17.0211 8.71432C16.7394 8.71432 16.435 8.56093 16.1646 8.28205C15.9301 8.04047 15.5141 8.00943 15.2352 8.21239C14.9563 8.41557 14.9203 8.77594 15.1548 9.01753C15.5074 9.3808 15.9221 9.63399 16.3615 9.76171V10.4286C16.3615 10.7443 16.6569 11 17.0211 11C17.3853 11 17.6806 10.7443 17.6806 10.4286V9.75903C18.4484 9.52303 19 8.8878 19 8.14295C19 7.1976 18.1123 6.42864 17.0211 6.42864C16.6574 6.42864 16.3615 6.17231 16.3615 5.85727C16.3615 5.54223 16.6574 5.28568 17.0211 5.28568C17.2549 5.28568 17.5015 5.38906 17.7345 5.58443C17.9964 5.80391 18.4139 5.79788 18.6673 5.57125C18.9206 5.3444 18.9137 4.9827 18.6521 4.76322C18.3173 4.48256 17.9822 4.32381 17.6806 4.23718V3.57159C17.6806 3.25587 17.3853 3 17.0211 3C16.6569 3 16.3615 3.25587 16.3615 3.57159Z"
								fill="#646464" />
						</svg>


					</i>
					<span class="flex-grow-1"
						aria-hidden="true">Payments</span>
				</a>
			</li> -->



		<!-- * Petty Cash Management -->
		<!-- <li class="nav-item"
			*ngIf="!authService.user?.isAdmin && !authService.user?.isLeadAdmin"
			routerLinkActive="active"
			role="none"
			pmdBoundary="viewport"
			container="body"
			containerClass="pf-menu-tooltip">
			<a class="nav-link"
				role="menuitem"
				[ngClass]="{'aTagDisabled' : !authService.secondaryOwnerCanAccess('/petty-expense')}"
				[routerLink]="['/petty-expense']">
				<i class="pmd-nav-item-icon">
					<svg width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M13.749 7.16699C15.0785 7.16699 16.3151 7.3617 17.2461 7.7002C17.7085 7.86836 18.1365 8.08644 18.4619 8.36621C18.7847 8.64383 19.0829 9.05246 19.083 9.58301V15.833C19.083 16.3638 18.7848 16.7731 18.4619 17.0508C18.1365 17.3306 17.7085 17.5486 17.2461 17.7168C16.3151 18.0553 15.0784 18.25 13.749 18.25C12.4196 18.25 11.1829 18.0553 10.252 17.7168C9.78955 17.5486 9.3625 17.3305 9.03711 17.0508C8.71416 16.7731 8.41602 16.3639 8.41602 15.833V9.58301L8.42969 9.38965C8.49126 8.9522 8.75467 8.60911 9.03711 8.36621C9.36247 8.08648 9.78959 7.86835 10.252 7.7002C11.1829 7.36165 12.4196 7.16702 13.749 7.16699ZM17.2461 14.5918C16.3151 14.9303 15.0784 15.125 13.749 15.125C12.4196 15.125 11.1829 14.9303 10.252 14.5918C10.1374 14.5501 10.0252 14.505 9.91602 14.457V15.8057C9.92581 15.8222 9.952 15.8584 10.0156 15.9131C10.1541 16.0321 10.3979 16.1733 10.7646 16.3066C11.4924 16.5713 12.5474 16.75 13.749 16.75C14.9507 16.75 16.0066 16.5713 16.7344 16.3066C17.1011 16.1732 17.345 16.0321 17.4834 15.9131C17.5472 15.8582 17.5733 15.8222 17.583 15.8057V14.457C17.4737 14.505 17.3608 14.5501 17.2461 14.5918ZM6.24902 1.75C7.5784 1.75 8.81508 1.94473 9.74609 2.2832C10.2085 2.45137 10.6365 2.66945 10.9619 2.94922C11.2848 3.2269 11.583 3.6362 11.583 4.16699V5.41699C11.5828 5.83095 11.247 6.16682 10.833 6.16699C10.5796 6.16699 10.3565 6.04009 10.2207 5.84766C10.0685 5.92042 9.91022 5.99012 9.74609 6.0498C8.81507 6.3883 7.57845 6.58301 6.24902 6.58301C4.91956 6.58298 3.68294 6.38835 2.75195 6.0498C2.6374 6.00814 2.52522 5.963 2.41602 5.91504V7.47168C2.42454 7.48607 2.44559 7.51621 2.49512 7.56152C2.61193 7.66838 2.82283 7.80042 3.14941 7.92969C3.79756 8.18623 4.74923 8.37384 5.85742 8.41016L6.24902 8.41699L6.32617 8.4209C6.70428 8.45939 6.99902 8.77873 6.99902 9.16699C6.99886 9.55513 6.70421 9.87464 6.32617 9.91309L6.24902 9.91699L5.80859 9.90918C4.58082 9.86895 3.44882 9.66109 2.59766 9.32422C2.53603 9.29983 2.47615 9.27154 2.41602 9.24512V10.8057C2.42581 10.8222 2.452 10.8584 2.51562 10.9131C2.65406 11.0321 2.89792 11.1733 3.26465 11.3066C3.9014 11.5382 4.78881 11.7044 5.80566 11.7422L6.24902 11.75L6.32617 11.7539C6.7043 11.7924 6.99902 12.1117 6.99902 12.5C6.99902 12.8883 6.7043 13.2076 6.32617 13.2461L6.24902 13.25L5.75586 13.2412C4.61559 13.1993 3.56672 13.0131 2.75195 12.7168C2.6374 12.6751 2.52521 12.63 2.41602 12.582V14.1387C2.42569 14.1551 2.45168 14.1921 2.51562 14.2471C2.65415 14.366 2.89809 14.5073 3.26465 14.6406C3.99236 14.9052 5.04745 15.083 6.24902 15.083C6.66313 15.083 6.99885 15.4189 6.99902 15.833C6.99902 16.2472 6.66324 16.583 6.24902 16.583C4.91956 16.583 3.68294 16.3883 2.75195 16.0498C2.28959 15.8817 1.86247 15.6635 1.53711 15.3838C1.21429 15.1062 0.916138 14.6976 0.916016 14.167V4.16699L0.929688 3.97363C0.991108 3.5358 1.25447 3.19224 1.53711 2.94922C1.8625 2.66947 2.28955 2.45136 2.75195 2.2832C3.68294 1.94466 4.91956 1.75003 6.24902 1.75ZM17.2461 11.4668C16.3151 11.8053 15.0784 12 13.749 12C12.4196 12 11.1829 11.8053 10.252 11.4668C10.1374 11.4251 10.0252 11.38 9.91602 11.332V12.6807C9.92581 12.6972 9.952 12.7334 10.0156 12.7881C10.1541 12.9071 10.3979 13.0483 10.7646 13.1816C11.4924 13.4463 12.5474 13.625 13.749 13.625C14.9507 13.625 16.0066 13.4463 16.7344 13.1816C17.1011 13.0482 17.345 12.9071 17.4834 12.7881C17.5472 12.7332 17.5733 12.6972 17.583 12.6807V11.332C17.4737 11.38 17.3608 11.4251 17.2461 11.4668ZM13.749 8.66699C12.5474 8.66702 11.4924 8.84475 10.7646 9.10938C10.3981 9.24267 10.1541 9.38399 10.0156 9.50293C9.97655 9.53653 9.95131 9.56368 9.93555 9.58301C9.95129 9.60237 9.97628 9.62926 10.0156 9.66309C10.1541 9.78206 10.3979 9.92326 10.7646 10.0566C11.4924 10.3213 12.5474 10.5 13.749 10.5C14.9507 10.5 16.0066 10.3213 16.7344 10.0566C17.1011 9.92325 17.345 9.78205 17.4834 9.66309C17.5225 9.62947 17.5467 9.60233 17.5625 9.58301C17.5467 9.56371 17.5223 9.53634 17.4834 9.50293C17.3449 9.38399 17.1009 9.2427 16.7344 9.10938C16.0066 8.84473 14.9507 8.66699 13.749 8.66699ZM6.24902 3.25C5.04744 3.25003 3.99236 3.42874 3.26465 3.69336C2.89792 3.82674 2.65406 3.96794 2.51562 4.08691C2.47668 4.1204 2.45132 4.1467 2.43555 4.16602C2.45128 4.18539 2.47615 4.21313 2.51562 4.24707C2.65415 4.36601 2.89809 4.50733 3.26465 4.64062C3.99236 4.90525 5.04745 5.08298 6.24902 5.08301C7.45074 5.08301 8.5066 4.90527 9.23438 4.64062C9.60094 4.5073 9.84495 4.36601 9.9834 4.24707C10.0227 4.21332 10.0468 4.18537 10.0625 4.16602C10.0467 4.14674 10.0221 4.1202 9.9834 4.08691C9.84502 3.96795 9.60107 3.82675 9.23438 3.69336C8.5066 3.42871 7.45074 3.25 6.24902 3.25Z"
							fill="#646464" />
					</svg>

				</i>
				<span class="flex-grow-1"
					aria-hidden="true">Petty expenses</span>
			</a>
		</li> -->
		<!-- * Push to Retail Pos -->

		<!-- <li class="nav-item position-relative "
			*ngIf="showPushToPetpooja && !authService.user?.isLeadAdmin"
			routerLinkActive="active"
			role="none"
			pmdBoundary="viewport"
			container="body"
			containerClass="pf-menu-tooltip">
			<div class="cursor-pointer"
				(click)="toggleSubmenu('p2poss')">
				<a class="nav-link"
					role="menuitem">
					<i class="pmd-nav-item-icon">

						<svg width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M6.95135 16.4702C3.38285 16.4702 0.479492 13.5677 0.479492 9.9992C0.479492 6.43071 3.38285 3.52734 6.95135 3.52734C10.5198 3.52734 13.4232 6.43071 13.4232 9.9992C13.4232 10.3276 13.1573 10.5944 12.828 10.5944C12.4988 10.5944 12.2329 10.3285 12.2329 9.9992C12.2329 7.08678 9.86376 4.71684 6.95052 4.71684C4.03728 4.71684 1.66899 7.08596 1.66899 9.9992C1.66899 12.9124 4.03811 15.2816 6.95135 15.2816C7.2798 15.2816 7.54651 15.5474 7.54651 15.8767C7.54651 16.206 7.28062 16.4719 6.95135 16.4719V16.4702Z"
								fill="#C52031"
								stroke="#C52031"
								stroke-width="0.3" />
							<path
								d="M14.072 16.471C11.0682 16.471 8.625 14.027 8.625 11.024C8.625 10.6955 8.89089 10.4288 9.22016 10.4288C9.54943 10.4288 9.81532 10.6947 9.81532 11.024C9.81532 13.3717 11.7251 15.2815 14.0728 15.2815C16.4205 15.2815 18.3303 13.3717 18.3303 11.024C18.3303 8.67627 16.4205 6.76649 14.0728 6.76649C13.7444 6.76649 13.4777 6.5006 13.4777 6.17133C13.4777 5.84206 13.7435 5.57617 14.0728 5.57617C17.0766 5.57617 19.5198 8.0202 19.5198 11.0232C19.5198 14.0261 17.0758 16.4702 14.0728 16.4702L14.072 16.471Z"
								fill="#C52031"
								stroke="#C52031"
								stroke-width="0.3" />
						</svg>


					</i>
					<span class="flex-grow-1"
						aria-hidden="true">Petpooja POSS</span>
				</a>
				<span class="material-symbols-outlined submenu-toggle-icon"
					[ngClass]="{'open': isSubmenuOpen.p2poss, 'arrow-show':isOpen}">
					keyboard_arrow_down
				</span>
			</div>
			<ul class="submenu"
				[ngClass]="{'open': isSubmenuOpen.p2poss}"
				*ngIf="isOpen">
				<li class="submenu-item"
					routerLinkActive="active">
					<a class="submenu-link"
						[ngClass]="{'aTagDisabled' : !authService.secondaryOwnerCanAccess('/push-to-petpooja') }"
						[routerLink]="['/push-to-petpooja']">Push To Petpooja POSS</a>
				</li>
				<li class="submenu-item"
					routerLinkActive="active">
					<a class="submenu-link"
						[ngClass]="{'aTagDisabled' : !authService.secondaryOwnerCanAccess('/push-to-petpooja/manage-poss-tags')}"
						[routerLink]="['/push-to-petpooja/manage-poss-tags']">Manage Tags</a>
				</li>
			</ul>
		</li> -->
		<!-- * Push to invoice -->

		<!-- <li class="nav-item position-relative "
			*ngIf="showPushToRetailPos && !authService.user?.isLeadAdmin"
			routerLinkActive="active"
			role="none"
			pmdBoundary="viewport"
			container="body"
			containerClass="pf-menu-tooltip">
			<div class="cursor-pointer"
				(click)="toggleSubmenu('p2Invoice')">
				<a class="nav-link"
					role="menuitem">
					<i class="pmd-nav-item-icon">
						<img src="assets/images/Petpooja-invoice.svg"
							alt="Petpooja-invoice.svg">
					</i>
					<span class="flex-grow-1"
						aria-hidden="true">Petpooja Invoice</span>
				</a>
				<span class="material-symbols-outlined submenu-toggle-icon"
					[ngClass]="{'open': isSubmenuOpen.p2Invoice, 'arrow-show':isOpen}">
					keyboard_arrow_down
				</span>
			</div>
			<ul class="submenu"
				[ngClass]="{'open': isSubmenuOpen.p2Invoice}"
				*ngIf="isOpen">
				<li class="submenu-item"
					routerLinkActive="active">
					<a class="submenu-link"
						[routerLink]="['/push-to-retail-pos']">Push to Petpooja Invoice</a>
				</li>
				<li class="submenu-item"
					routerLinkActive="active">
					<a class="submenu-link"
						[routerLink]="['/push-to-retail-pos/manage-invoice-tags']">Manage Tags</a>
				</li>
			</ul>
		</li> -->
		<!-- * Push to invoice -->
		<!-- 
		<li class="nav-item position-relative"
			*ngIf="showPushToTally && !authService.user?.isLeadAdmin"
			routerLinkActive="active"
			role="none"
			pmdBoundary="viewport"
			container="body"
			containerClass="pf-menu-tooltip">
			<div class="cursor-pointer"
				(click)="toggleSubmenu('p2Telly')">
				<a class="nav-link"
					role="menuitem">
					<i class="pmd-nav-item-icon">
						<img src="assets/images/tally-icons.png"
							alt="tally-icons.png">
					</i>
					<span class="flex-grow-1"
						aria-hidden="true">Tally ERP</span>
				</a>
				<span class="material-symbols-outlined submenu-toggle-icon"
					[ngClass]="{'open': isSubmenuOpen.p2Telly, 'arrow-show':isOpen}">
					keyboard_arrow_down
				</span>
			</div>
			<ul class="submenu"
				[ngClass]="{'open': isSubmenuOpen.p2Telly}"
				*ngIf="isOpen">
				<li class="submenu-item"
					routerLinkActive="active">
					<a class="submenu-link"
						[routerLink]="['/push-to-tally']">Push To Tally ERP</a>
				</li>
				<li class="submenu-item"
					routerLinkActive="active">
					<a class="submenu-link"
						[routerLink]="['/tally-config']">Manage Tags</a>
				</li>
			</ul>
		</li> -->
		<!-- * Report Management -->
		<!-- <li class="nav-item"
			*ngIf="authService.user?.isOwner || authService.user?.isOutlet || (authService.user?.isLeadAdmin && isLeadAdminModuleAccess)"
			routerLinkActive="active"
			role="none"
			pmdBoundary="viewport"
			container="body"
			containerClass="pf-menu-tooltip">
			<a class="nav-link"
				role="menuitem"
				[ngClass]="{'aTagDisabled' : !authService.secondaryOwnerCanAccess('/report')}"
				[routerLink]="['/report']">
				<i class="pmd-nav-item-icon">
					<svg width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M2.58399 14.335V5.66801C2.58399 4.98032 2.58299 4.41939 2.62012 3.96488C2.65797 3.50163 2.73939 3.08316 2.93848 2.69242L3.06348 2.46879C3.37571 1.9597 3.82336 1.54516 4.3584 1.2725L4.50684 1.20317C4.85492 1.05392 5.22564 0.987251 5.63086 0.954142C6.08537 0.917007 6.6463 0.918009 7.33399 0.918009H10.0107C10.5864 0.918007 10.9966 0.91325 11.3906 1.00785L11.6367 1.07719C11.7413 1.11118 11.8429 1.15294 11.9434 1.19731C11.9592 1.20358 11.974 1.21149 11.9893 1.21879C12.1056 1.27235 12.2205 1.3294 12.3301 1.39652L12.457 1.48051C12.7489 1.6841 13.0129 1.9534 13.3691 2.30961L16.0264 4.96586L16.3105 5.25199C16.5747 5.5205 16.7797 5.74676 16.9385 6.0059L17.0635 6.22856C17.0831 6.26713 17.0991 6.30741 17.1172 6.34672C17.1245 6.36197 17.1324 6.37682 17.1387 6.39262C17.2172 6.5706 17.2816 6.75466 17.3272 6.94438L17.3584 7.09379C17.403 7.34409 17.4144 7.60793 17.417 7.92192V14.335C17.417 15.0225 17.418 15.5837 17.3809 16.0381C17.3477 16.4432 17.282 16.8142 17.1328 17.1621L17.0635 17.3106C16.7907 17.8458 16.3755 18.2933 15.8662 18.6055L15.6426 18.7305C15.2519 18.9295 14.8333 19.01 14.3701 19.0479C13.9157 19.085 13.3546 19.085 12.667 19.085H7.33399C6.6463 19.085 6.08537 19.085 5.63086 19.0479C5.22571 19.0148 4.85487 18.949 4.50684 18.7998L4.3584 18.7305C3.82339 18.4579 3.37573 18.0432 3.06348 17.5342L2.93848 17.3106C2.73944 16.9199 2.65798 16.5013 2.62012 16.0381C2.58299 15.5837 2.58399 15.0225 2.58399 14.335ZM5.91699 15.001V12.501C5.91717 12.0871 6.25304 11.7512 6.667 11.751C7.0811 11.751 7.41682 12.087 7.417 12.501V15.001C7.417 15.4152 7.08121 15.751 6.667 15.751C6.25293 15.7508 5.91699 15.4151 5.91699 15.001ZM9.25098 15.001V8.75102C9.25116 8.33695 9.58687 8.00102 10.001 8.00102C10.4149 8.00119 10.7508 8.33706 10.751 8.75102V15.001C10.751 15.4151 10.415 15.7508 10.001 15.751C9.58677 15.751 9.25098 15.4152 9.25098 15.001ZM12.584 15.001V10.835C12.584 10.4208 12.9198 10.085 13.334 10.085C13.7482 10.085 14.084 10.4208 14.084 10.835V15.001C14.084 15.4152 13.7482 15.751 13.334 15.751C12.9198 15.751 12.584 15.4152 12.584 15.001ZM4.08399 14.335C4.08399 15.0473 4.08426 15.5369 4.11524 15.9161C4.1455 16.286 4.20113 16.485 4.27442 16.6289L4.3418 16.75C4.50985 17.024 4.75118 17.2468 5.03907 17.3936L5.15918 17.4454C5.29331 17.4934 5.47482 17.53 5.75293 17.5528C6.13219 17.5838 6.62155 17.585 7.33399 17.585H12.667C13.3793 17.585 13.8688 17.5837 14.248 17.5528C14.6185 17.5225 14.8179 17.467 14.9619 17.3936L15.082 17.3262C15.3562 17.1581 15.5797 16.9171 15.7266 16.6289L15.7783 16.5088C15.8263 16.3748 15.8631 16.1935 15.8857 15.9161C15.9167 15.5369 15.917 15.0473 15.917 14.335V8.32524C15.917 7.81603 15.9131 7.58262 15.8906 7.41801H13.001C12.7801 7.41801 12.5691 7.41874 12.3926 7.40434C12.2535 7.39297 12.0987 7.36994 11.9404 7.31352L11.7822 7.24516C11.5215 7.11231 11.3035 6.91024 11.1514 6.66215L11.0898 6.55375C10.9816 6.34138 10.9468 6.12867 10.9316 5.9434C10.9172 5.76688 10.917 5.55588 10.917 5.335V2.44438C10.7524 2.42195 10.5194 2.41801 10.0107 2.41801H7.33399C6.62155 2.41801 6.13219 2.41827 5.75293 2.44926C5.47472 2.472 5.29333 2.50957 5.15918 2.55766L5.03907 2.60844C4.75098 2.75528 4.5099 2.97883 4.3418 3.25297L4.27442 3.37309C4.20103 3.51711 4.14551 3.71652 4.11524 4.08695C4.08425 4.46621 4.08399 4.95557 4.08399 5.66801V14.335ZM12.417 5.335C12.417 5.58057 12.4175 5.72003 12.4258 5.82133C12.4282 5.85098 12.4316 5.87031 12.4336 5.88188C12.4386 5.889 12.4442 5.8952 12.4512 5.90043C12.4624 5.90241 12.4826 5.9066 12.5147 5.90922C12.616 5.91748 12.7555 5.91801 13.001 5.91801H14.8574L12.417 3.47758V5.335Z"
							fill="#646464" />
					</svg>
				</i>
				<span class="flex-grow-1"
					aria-hidden="true">Report</span>
			</a>
		</li> -->
		<!-- <li class="nav-item"
				*ngIf="!authService.user?.isLeadAdmin && !authService.user?.isAdmin"
				routerLinkActive="active"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<a class="nav-link"
					role="menuitem"
					[routerLink]="['/integrations']">
					<i class="pmd-nav-item-icon">
						<svg width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_3818_10114)">
								<path
									d="M14.249 14.335V12.918C14.249 12.5039 14.585 12.1681 14.999 12.168H16.249C16.9853 12.168 17.5828 11.5712 17.583 10.835C17.583 10.0986 16.9854 9.50098 16.249 9.50098H14.999C14.585 9.5008 14.249 9.16508 14.249 8.75098C14.249 8.15854 14.2492 7.75169 14.2275 7.43457C14.2116 7.20148 14.1859 7.04773 14.1523 6.93359L14.1162 6.83203C13.9608 6.45678 13.6802 6.14904 13.3252 5.95898L13.1689 5.88477C13.0459 5.83379 12.8767 5.79462 12.5664 5.77344C12.2492 5.7518 11.8417 5.75098 11.249 5.75098H10.416C10.0018 5.75098 9.66602 5.41519 9.66602 5.00098V3.75098C9.66584 3.01485 9.06913 2.41814 8.33301 2.41797C7.59674 2.41797 6.9992 3.01475 6.99903 3.75098V5.00098C6.99903 5.41519 6.66324 5.75098 6.24903 5.75098H5.41602C4.82359 5.75098 4.41674 5.75182 4.09961 5.77344C3.86667 5.78933 3.71275 5.81514 3.59864 5.84863L3.4961 5.88477C3.12106 6.04019 2.81306 6.32004 2.62305 6.6748L2.54883 6.83203C2.49794 6.95509 2.45963 7.12454 2.43848 7.43457C2.42747 7.59594 2.42171 7.78051 2.41895 8.00098H2.91602C4.48082 8.00098 5.74903 9.27015 5.74903 10.835C5.74885 12.3996 4.48072 13.668 2.91602 13.668H2.41602V14.335C2.41602 15.0472 2.41629 15.5368 2.44727 15.916C2.47753 16.286 2.53316 16.4849 2.60645 16.6289L2.67383 16.75C2.84188 17.0239 3.08321 17.2468 3.3711 17.3936L3.49121 17.4453C3.62534 17.4934 3.80685 17.53 4.08496 17.5527C4.46422 17.5837 4.95358 17.585 5.66602 17.585H5.91602V16.876C5.91619 15.4264 7.09138 14.251 8.54102 14.251C9.99066 14.251 11.1658 15.4264 11.166 16.876V17.584C11.7892 17.5837 12.2312 17.5812 12.5801 17.5527C12.9506 17.5225 13.1499 17.4669 13.2939 17.3936L13.4141 17.3262C13.6883 17.158 13.9118 16.9171 14.0586 16.6289L14.1104 16.5088C14.1583 16.3748 14.1951 16.1935 14.2178 15.916C14.2488 15.5368 14.249 15.0472 14.249 14.335ZM11.166 4.25098H11.249C11.821 4.25098 12.2879 4.25046 12.668 4.27637C13.0548 4.30276 13.4068 4.35971 13.7432 4.49902L13.8906 4.56445C14.6174 4.9087 15.1928 5.51135 15.502 6.25781L15.5918 6.5127C15.6676 6.77159 15.7038 7.04194 15.7236 7.33203C15.7372 7.53042 15.7431 7.75273 15.7461 8.00098H16.249C17.8138 8.00098 19.083 9.27015 19.083 10.835C19.0828 12.3996 17.8137 13.668 16.249 13.668H15.749V14.335C15.749 15.0225 15.75 15.5837 15.7129 16.0381C15.6798 16.4432 15.6141 16.8141 15.4648 17.1621L15.3955 17.3105C15.1228 17.8457 14.7075 18.2932 14.1982 18.6055L13.9746 18.7305C13.5839 18.9295 13.1653 19.01 12.7022 19.0479C12.2477 19.085 11.6866 19.085 10.999 19.085H10.416C10.0019 19.085 9.66619 18.749 9.66602 18.335V16.876C9.66584 16.2548 9.16223 15.751 8.54102 15.751C7.91981 15.751 7.41619 16.2548 7.41602 16.876V18.335C7.41584 18.749 7.08012 19.085 6.66602 19.085H5.66602C4.97833 19.085 4.4174 19.085 3.96289 19.0479C3.55774 19.0147 3.1869 18.949 2.83887 18.7998L2.69043 18.7305C2.15542 18.4578 1.70776 18.0432 1.39551 17.5342L1.27051 17.3105C1.07147 16.9199 0.990013 16.5012 0.952151 16.0381C0.915022 15.5837 0.916018 15.0225 0.916018 14.335V12.918L0.919924 12.8408C0.958546 12.4629 1.27785 12.168 1.66602 12.168H2.91602C3.65229 12.168 4.24885 11.5712 4.24903 10.835C4.24903 10.0986 3.6524 9.50098 2.91602 9.50098H1.66602C1.2518 9.50098 0.916018 9.16519 0.916018 8.75098C0.916018 8.17896 0.91548 7.71205 0.941409 7.33203C0.967803 6.94545 1.02391 6.59396 1.16309 6.25781L1.22852 6.11035C1.57265 5.38353 2.17546 4.80834 2.92188 4.49902L3.17774 4.40918C3.43667 4.33337 3.70693 4.29616 3.99707 4.27637C4.37716 4.25044 4.84387 4.25098 5.41602 4.25098H5.49903V3.75098C5.4992 2.18632 6.76831 0.917969 8.33301 0.917969C9.89756 0.918144 11.1658 2.18643 11.166 3.75098V4.25098Z"
									fill="#646464" />
							</g>
							<defs>
								<clipPath id="clip0_3818_10114">
									<rect width="20"
										height="20"
										fill="white" />
								</clipPath>
							</defs>
						</svg>
					</i>
					<span class="flex-grow-1"
						aria-hidden="true">Integrations</span>
				</a>
			</li> -->

		<!-- * Invoice Review Summary -->
		<!-- <li class="nav-item"
			routerLinkActive="active"
			*ngIf="authService.user?.isLeadAdmin && isLeadAdminModuleAccess"
			role="none"
			pmdBoundary="viewport"
			container="body"
			containerClass="pf-menu-tooltip">
			<a class="nav-link"
				role="menuitem"
				[routerLink]="['/invoice-review-summary']">
				<i class="pmd-nav-item-icon">
					<svg xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="20"
						fill="currentColor"
						class="bi bi-file-earmark-text"
						viewBox="0 0 16 16">
						<path
							d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
						<path
							d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
					</svg>
				</i>
				<span class="flex-grow-1"
					aria-hidden="true">Invoice Summary</span>
			</a>
		</li> -->

		<!-- * Buyer -->
		<!-- <li class="nav-item"
			routerLinkActive="active"
			*ngIf="authService.user?.isLeadAdmin && isLeadAdminModuleAccess"
			role="none"
			pmdBoundary="viewport"
			container="body"
			containerClass="pf-menu-tooltip">
			<a class="nav-link"
				role="menuitem"
				[routerLink]="['/buyer']">
				<i class="pmd-nav-item-icon">
					<svg xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="20"
						fill="currentColor"
						class="bi bi-file-earmark-text"
						viewBox="0 0 16 16">
						<path
							d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
						<path
							d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
					</svg>
				</i>
				<span class="flex-grow-1"
					aria-hidden="true">Buyer</span>
			</a>
		</li> -->

		<!-- * User Management -->
		<!-- <li class="nav-item"
				routerLinkActive="active"
				*ngIf="authService.user?.isLeadAdmin && isLeadAdminModuleAccess"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<a class="nav-link"
					role="menuitem"
					[routerLink]="['/lead-admin-user-management']">
					<i class="pmd-nav-item-icon">
						<svg xmlns="http://www.w3.org/2000/svg"
							width="20"
							height="20"
							fill="currentColor"
							class="bi bi-person-gear"
							viewBox="0 0 16 16">
							<path
								d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
						</svg>
					</i>
					<span class="flex-grow-1"
						aria-hidden="true">User Management</span>
				</a>
			</li> -->

		<!-- * Supplier -->
		<!-- <li class="nav-item"
				routerLinkActive="active"
				*ngIf="authService.user?.isLeadAdmin && isLeadAdminModuleAccess"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<a class="nav-link"
					role="menuitem"
					[routerLink]="['/supplier']">
					<i class="pmd-nav-item-icon">
						<svg width="20"
							height="20"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_1733_91374)">
								<path
									d="M5.29 5.58333C6.55317 5.58333 7.58167 4.55575 7.58167 3.29167C7.58167 2.02758 6.55317 1 5.29 1C4.02683 1 2.99833 2.02758 2.99833 3.29167C2.99833 4.55575 4.02683 5.58333 5.29 5.58333ZM5.29 1.91667C6.04808 1.91667 6.665 2.53358 6.665 3.29167C6.665 4.04975 6.04808 4.66667 5.29 4.66667C4.53192 4.66667 3.915 4.04975 3.915 3.29167C3.915 2.53358 4.53192 1.91667 5.29 1.91667ZM6.5 9.25H7.41667V23H6.5V16.5833H3.75V23H2.83333V16.5833H1V8.79167C1 7.52758 2.0285 6.5 3.29167 6.5H14.75V7.41667H3.29167C2.53358 7.41667 1.91667 8.03358 1.91667 8.79167V15.6667H6.5V9.25ZM21.1667 15.6667H19.7917V11.0833C19.7917 10.0723 18.9694 9.25 17.9583 9.25H14.2917C13.2806 9.25 12.4583 10.0723 12.4583 11.0833V15.6667H11.0833C10.0723 15.6667 9.25 16.4889 9.25 17.5V23H23V17.5C23 16.4889 22.1778 15.6667 21.1667 15.6667ZM13.375 11.0833C13.375 10.5773 13.7866 10.1667 14.2917 10.1667H17.9583C18.4634 10.1667 18.875 10.5773 18.875 11.0833V15.6667H13.375V11.0833ZM15.6667 22.0833H10.1667V17.5C10.1667 16.994 10.5783 16.5833 11.0833 16.5833H14.75C15.2551 16.5833 15.6667 16.994 15.6667 17.5V22.0833ZM22.0833 22.0833H16.5833V17.5C16.5833 16.994 16.9949 16.5833 17.5 16.5833H21.1667C21.6718 16.5833 22.0833 16.994 22.0833 17.5V22.0833ZM17.0417 12H15.2083V11.0833H17.0417V12ZM18.4167 17.5H20.25V18.4167H18.4167V17.5ZM12 17.5H13.8333V18.4167H12V17.5Z"
									fill="#646464"
									stroke="#646464"
									stroke-width="0.4" />
								<path fill-rule="evenodd"
									clip-rule="evenodd"
									d="M2.79838 3.29245C2.79838 1.91786 3.91648 0.800781 5.29005 0.800781C6.66362 0.800781 7.78171 1.91786 7.78171 3.29245C7.78171 4.66704 6.66362 5.78411 5.29005 5.78411C3.91648 5.78411 2.79838 4.66704 2.79838 3.29245ZM5.29005 1.20078C4.13729 1.20078 3.19838 2.13887 3.19838 3.29245C3.19838 4.44602 4.13729 5.38411 5.29005 5.38411C6.44281 5.38411 7.38172 4.44602 7.38172 3.29245C7.38172 2.13887 6.44281 1.20078 5.29005 1.20078ZM5.29005 2.11745C4.64242 2.11745 4.11505 2.64482 4.11505 3.29245C4.11505 3.94007 4.64242 4.46745 5.29005 4.46745C5.93767 4.46745 6.46505 3.94007 6.46505 3.29245C6.46505 2.64482 5.93767 2.11745 5.29005 2.11745ZM3.71505 3.29245C3.71505 2.42391 4.42151 1.71745 5.29005 1.71745C6.15859 1.71745 6.86505 2.42391 6.86505 3.29245C6.86505 4.16099 6.15859 4.86745 5.29005 4.86745C4.42151 4.86745 3.71505 4.16099 3.71505 3.29245ZM3.29172 6.70078C2.13895 6.70078 1.20005 7.63887 1.20005 8.79245V16.3841H3.03338V22.8008H3.55005V16.3841H6.70005V22.8008H7.21672V9.45078H6.70005V15.8674H1.71672V8.79245C1.71672 7.92391 2.42318 7.21745 3.29172 7.21745H14.55V6.70078H3.29172ZM0.800049 8.79245C0.800049 7.41786 1.91814 6.30078 3.29172 6.30078H14.95V7.61745H3.29172C2.64409 7.61745 2.11672 8.14482 2.11672 8.79245V15.4674H6.30005V9.05078H7.61672V23.2008H6.30005V16.7841H3.95005V23.2008H2.63338V16.7841H0.800049V8.79245ZM12.2584 11.0841C12.2584 9.96257 13.1702 9.05078 14.2917 9.05078H17.9584C19.0799 9.05078 19.9917 9.96257 19.9917 11.0841V15.4674H21.1667C22.2883 15.4674 23.2001 16.3792 23.2001 17.5008V23.2008H9.05005V17.5008C9.05005 16.3792 9.96184 15.4674 11.0834 15.4674H12.2584V11.0841ZM14.2917 9.45078C13.3911 9.45078 12.6584 10.1835 12.6584 11.0841V15.8674H11.0834C10.1828 15.8674 9.45005 16.6002 9.45005 17.5008V22.8008H22.8V17.5008C22.8 16.6002 22.0673 15.8674 21.1667 15.8674H19.5917V11.0841C19.5917 10.1835 18.859 9.45078 17.9584 9.45078H14.2917ZM14.2917 10.3674C13.897 10.3674 13.575 10.6887 13.575 11.0841V15.4674H18.675V11.0841C18.675 10.6887 18.3531 10.3674 17.9584 10.3674H14.2917ZM13.175 11.0841C13.175 10.4675 13.6763 9.96745 14.2917 9.96745H17.9584C18.5738 9.96745 19.0751 10.4675 19.0751 11.0841V15.8674H13.175V11.0841ZM15.0084 10.8841H17.2417V12.2008H15.0084V10.8841ZM15.4084 11.2841V11.8008H16.8417V11.2841H15.4084ZM11.0834 16.7841C10.6886 16.7841 10.3667 17.1054 10.3667 17.5008V21.8841H15.4667V17.5008C15.4667 17.1054 15.1448 16.7841 14.75 16.7841H11.0834ZM9.96672 17.5008C9.96672 16.8842 10.468 16.3841 11.0834 16.3841H14.75C15.3655 16.3841 15.8667 16.8842 15.8667 17.5008V22.2841H9.96672V17.5008ZM17.5 16.7841C17.1053 16.7841 16.7834 17.1054 16.7834 17.5008V21.8841H21.8834V17.5008C21.8834 17.1054 21.5615 16.7841 21.1667 16.7841H17.5ZM16.3834 17.5008C16.3834 16.8842 16.8846 16.3841 17.5 16.3841H21.1667C21.7821 16.3841 22.2834 16.8842 22.2834 17.5008V22.2841H16.3834V17.5008ZM11.8 17.3008H14.0334V18.6175H11.8V17.3008ZM12.2 17.7008V18.2174H13.6334V17.7008H12.2ZM18.2167 17.3008H20.4501V18.6175H18.2167V17.3008ZM18.6167 17.7008V18.2174H20.05V17.7008H18.6167Z"
									fill="#646464" />
							</g>
							<defs>
								<clipPath id="clip0_1733_91374">
									<rect width="20"
										height="20"
										fill="white" />
								</clipPath>
							</defs>
						</svg>
					</i>
					<span class="flex-grow-1"
						aria-hidden="true">Supplier</span>
				</a>
			</li>
			<li class="nav-item"
				routerLinkActive="active"
				*ngIf="authService.user?.isLeadAdmin"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<a class="nav-link"
					role="menuitem"
					[routerLink]="['/kyc-details']">
					<i class="pmd-nav-item-icon">
						<svg xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none">
							<g>
								<circle cx="12"
									cy="8"
									r="4"
									fill="#90CAF9"
									stroke="#42A5F5"
									stroke-width="1.5" />
								<path d="M16 16L19 19L23 13"
									fill="none"
									stroke="#66BB6A"
									stroke-width="1.5" />
								<rect x="2"
									y="12"
									width="16"
									height="8"
									fill="#E3F2FD"
									stroke="#42A5F5"
									stroke-width="1" />
								<line x1="4"
									y1="14"
									x2="14"
									y2="14"
									stroke="#42A5F5"
									stroke-width="1.2" />
								<line x1="4"
									y1="16"
									x2="14"
									y2="16"
									stroke="#42A5F5"
									stroke-width="1.2" />
								<line x1="4"
									y1="18"
									x2="10"
									y2="18"
									stroke="#42A5F5"
									stroke-width="1.2" />
							</g>
						</svg>
					</i>
					<span class="flex-grow-1"
						aria-hidden="true">KYC Details</span>
				</a>
			</li>
			<li class="nav-item"
				routerLinkActive="active"
				*ngIf="authService.user?.isLeadAdmin"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<a class="nav-link"
					role="menuitem"
					[routerLink]="['/account-dashboard']">
					<i class="pmd-nav-item-icon">
						<svg width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M14.5833 14.1667H5.41667M14.5833 10.8333H5.41667M2.5 7.5H17.5M6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5Z"
								stroke="#646464"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round" />
						</svg>
					</i>
					<span class="flex-grow-1"
						aria-hidden="true">Account Dashboard</span>
				</a>
			</li>
			<li class="nav-item"
				routerLinkActive="active"
				*ngIf="authService.user?.isLeadAdmin"
				role="none"
				pmdBoundary="viewport"
				container="body"
				containerClass="pf-menu-tooltip">
				<a class="nav-link"
					role="menuitem"
					[routerLink]="['/admin-account']">
					<span class="material-symbols-outlined"> account_circle</span>
					<span class="flex-grow-1"
						aria-hidden="true">Admin Account</span>
				</a>
			</li> -->
		<!-- </ng-container> -->

	</ul>
	<ng-container>
		<div class="circle_percent ps-3 circle_open_hover"
			[ngClass]="{'free-trial-over': +authService.user?.remainingFreeTrialDays <= 0}"
			*ngIf="
			((loggedinUser.isOwner
			||
			loggedinUser.isOutlet)
			&&
			!authService.user?.isPaidUser)">
			<span class="position-relative">
				<svg>
					<circle cx="25"
						cy="25"
						r="20"></circle>
					<circle cx="25"
						cy="25"
						r="20"
						[ngStyle]="{ '--percent': getTrialPercent() + '%' }"></circle>
				</svg>
				<div class="number">
					<h3 class="mb-0">{{getRemainingFreeTrialDays()}}</h3>
				</div>
			</span>
		</div>
		<ng-container *ngIf="((loggedinUser.isOwner || loggedinUser.isOutlet) && !authService.user?.isPaidUser)">
			<div class="my-0 free-trial-card"
				[ngClass]="{'free-trial-over': +authService.user?.remainingFreeTrialDays <= 0}">
				<div class="d-flex align-items-center gap-2">
					<div class="circle_percent"
						joyrideStep="secondStep"
						[stepContent]="customContent02"
						[prevTemplate]="prevButton"
						[nextTemplate]="nextButton">
						<ng-template #customContent02>
							<div class="p-4">
								<h5 class="text-dark fw-bold">2/<span class="text-desc fw-medium">4</span> Free Trial
									Duration</h5>
								<p class="fs-14 mb-1">You can check the days left in your free trial and upgrade to the
									premium plan by clicking here.</p>
							</div>
						</ng-template>
						<ng-template #prevButton>
							<button type="button"
								pmdRipple
								pmd-btn-outline
								color="dark"
								class="w-100">Back</button>
						</ng-template>
						<ng-template #nextButton>
							<button type="button"
								pmdRipple
								pmd-btn
								color="secondary"
								class="w-100">Next</button>
						</ng-template>
						<ng-container
							*ngIf="((loggedinUser.isOwner || loggedinUser.isOutlet) && !authService.user?.isPaidUser)">
							<svg>
								<circle cx="25"
									cy="25"
									r="20"></circle>
								<circle cx="25"
									cy="25"
									r="20"
									[ngStyle]="{ '--percent': getTrialPercent() + '%' }"></circle>
							</svg>
							<div class="number">
								<h3 class="mb-0">{{getRemainingFreeTrialDays()}}</h3>
							</div>
						</ng-container>
					</div>
					<div class="content-right-card"
						*ngIf="((loggedinUser.isOwner || loggedinUser.isOutlet) && !authService.user?.isPaidUser)">
						<p class="mb-1 text-xs">Free Trial</p>
						<ng-container *ngIf="+authService.user?.remainingFreeTrialDays else expiredTemplate">
							<p class="mb-0 fw-semibold text-dark text-xs over-text-subtitle">Ongoing,
								{{getRemainingFreeTrialDays()}}
								Days Left</p>
						</ng-container>
						<ng-template #expiredTemplate>
							<p class="mb-0 fw-semibold text-dark text-xs over-text-subtitle">
								Expired!</p>
						</ng-template>
					</div>
				</div>
				<button type="button"
					pmdRipple
					pmd-btn-outline
					color="dark"
					class="px-3 w-100 mt-3 make-pay-button text-xs"
					*ngIf="((loggedinUser.isOwner || loggedinUser.isOutlet) && !authService.user?.isPaidUser)"
					(click)="onOpenConfirmDetailModalComponent()">Upgrade to Premium</button>
			</div>
		</ng-container>
		<hr class="px-4">
		<ul class="nav flex-column pmd-sidebar-nav cursor-pointer">
			<ng-container *ngFor="let section of bottomSections; index as i">
				<ng-container *ngFor="let menu of section.menus">
					<li class="nav-item">
						<a [routerLink]="menu.path || (menu.subMenus?.length ? menu.subMenus[0].path : null)"
							quicklink
							class="nav-link"
							[ngClass]="{'active': menu.name === activeMenu?.name}"
							[routerLinkActive]="menu.path ? 'active' : ''"
							(click)="openInnerSidebar(menu)">
							<i class="pmd-nav-item-icon"
								*ngIf="menu.svg"
								[innerHTML]="menu.svg | safeHtml">

							</i>
							<span class="flex-grow-1">Settings</span>
							<span *ngIf="menu.subMenus?.length"
								class="hide-on-brand">
								<svg width="6"
									height="11"
									viewBox="0 0 7 12"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_4453_14990)">
										<path
											d="M0.721623 0.262639C1.01452 -0.0302546 1.48928 -0.0302545 1.78217 0.262639L6.78217 5.26264C6.92282 5.40329 7.0019 5.594 7.0019 5.79291C7.0019 5.99182 6.92282 6.18253 6.78217 6.32319L1.78217 11.3232C1.48928 11.6161 1.01451 11.6161 0.721623 11.3232C0.428737 11.0303 0.428747 10.5555 0.721623 10.2626L5.19135 5.79291L0.721623 1.32319C0.42873 1.03029 0.42873 0.555532 0.721623 0.262639Z"
											fill="#373737" />
									</g>
									<defs>
										<clipPath id="clip0_4453_14990">
											<rect width="7"
												height="12"
												fill="white" />
										</clipPath>
									</defs>
								</svg>
							</span>
						</a>
					</li>
				</ng-container>
			</ng-container>
		</ul>
		<div class="pb-3 pt-2 px-3 d-flex align-items-center justify-content-between">
			<span class="pmd-avatar bg-secondary text-white fs-14">
				<div class="image-profile-page d-flex align-items-center gap-2"
					*ngIf="loggedInUserThumbnail else elseTemplate">
					<img [src]="loggedInUserThumbnail || 'assets/images/placeholder-image.png'"
						class="profile-img object-fit-cover"
						alt="placeholder-image.png" />
				</div>
				<ng-template #elseTemplate
					class="me-0 me-sm-2">
					{{loggedinUser.shortName?.slice(0, 3)}}
				</ng-template>
			</span>
			<div class="flex-grow-1 khr-logedin-user"
				[pmdTooltip]="loggedinUser.name"
				placement="top">
				<p class="mb-0 text-black fw-semibold text-truncate">
					{{ loggedinUser.name }}
				</p>
			</div>
			<span (click)="logout()"
				class="cursor-pointer logout-link"
				pmdTooltip="Logout"
				placement="top">
				<svg width="18"
					height="16"
					viewBox="0 0 16 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M0.833496 7C0.833496 3.42825 3.62631 0.500239 7.11084 0.5C8.11387 0.5 9.0629 0.743736 9.90381 1.17676L10.2573 1.37402L10.3384 1.43457C10.5099 1.59183 10.5537 1.8533 10.4292 2.06055C10.3048 2.26756 10.0537 2.3517 9.83447 2.27441L9.74268 2.23145L9.44678 2.06641C8.74249 1.70355 7.94953 1.5 7.11084 1.5C4.21382 1.50024 1.8335 3.94463 1.8335 7C1.8335 10.0554 4.21382 12.4998 7.11084 12.5C8.06918 12.5 8.96765 12.2341 9.74268 11.7686L9.83447 11.7256C10.0537 11.6483 10.3048 11.7324 10.4292 11.9395C10.5714 12.1762 10.494 12.4838 10.2573 12.626L9.90381 12.8232C9.06291 13.2563 8.11387 13.5 7.11084 13.5C3.62631 13.4998 0.833496 10.5717 0.833496 7ZM11.647 3.97949C11.8178 3.80896 12.081 3.78806 12.2749 3.91602L12.354 3.97949L15.02 6.64648C15.2153 6.84174 15.2153 7.15825 15.02 7.35352L12.354 10.0205C12.1588 10.2157 11.8423 10.2155 11.647 10.0205C11.4517 9.82525 11.4517 9.50874 11.647 9.31348L13.4595 7.5H6.00049C5.72435 7.5 5.50049 7.27614 5.50049 7C5.50049 6.72386 5.72435 6.5 6.00049 6.5H13.4595L11.647 4.68652L11.5825 4.6084C11.4544 4.41433 11.4761 4.15033 11.647 3.97949Z"
						fill="black" />
				</svg>
			</span>
		</div>
	</ng-container>
</div>